import useTranslation from 'next-translate/useTranslation';
import styles from '../styles.module.scss';
import { AuthModalContentLoginLayoutOptProps } from './props';
import OAuthRow from '../../../OAuth';
import { ModalsKey } from '@/enums/modalsKey';
import Link from '@/components/core/Link';

export default function AuthModalContentLoginLayoutOpt({
  isVariant,
  showOauth,
}: AuthModalContentLoginLayoutOptProps) {
  const { t: tRegister } = useTranslation('register');
  const { t } = useTranslation('login');

  return (
    <>
      {showOauth && (
        <>
          <span className={styles.container__binding}>
            {tRegister('register_label_binding')}
          </span>
          <OAuthRow direction={isVariant ? 'row' : 'column'} />
        </>
      )}
      {!isVariant && (
        <span className={styles.container__text}>
          {t('register_text')}
          <Link
            modal={ModalsKey.Register}
            className={styles.container__text__highlight}
          >
            {t('register_label')}
          </Link>
        </span>
      )}
    </>
  );
}
